export default "__VITE_ASSET__DxRdc1p3__"